import ValentineCard from "./components/ValentineCard";
import Hearts from "./components/Hearts";

export default function App() {
  return (
    <div className="app">
      <Hearts />
      <ValentineCard />
    </div>
  );
}
